import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  PageWrapper,
  Header,
  StepDots,
  StepDot,
  StepLabel,
} from './styledComponents';
import StepUbicacion from './steps/StepUbicacion';
import StepDatos from './steps/StepDatos';
import StepConfirmacion from './steps/StepConfirmacion';
import { registerCampaign } from './api';
import { buildRegisterCampaignPayload } from './api/buildRegisterPayload';
import { TYPES, useGlobalActions } from '../../context/globalActions';

const STEPS = [
  { label: 'UBICACIÓN' },
  { label: 'TUS DATOS' },
  { label: 'CONFIRMACIÓN' },
];

export default function RegistroCampaña() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const cityCodeNameFromUrl = params.get('cityCodeName');

  const [currentStep, setCurrentStep] = useState(cityCodeNameFromUrl ? 1 : 0);
  const [subLabel, setSubLabel] = useState(null);
  const [formData, setFormData] = useState(
    cityCodeNameFromUrl ? { cityCodeName: cityCodeNameFromUrl } : {},
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { handleOpenSnackbar } = useGlobalActions();

  const handleNext = async data => {
    const newFormData = {
      ...formData,
      ...data,
    };

    setFormData(newFormData);

    if (currentStep === 1) {
      setIsSubmitting(true);
      try {
        const payload = buildRegisterCampaignPayload(
          newFormData,
          'INIT_BRANCH',
        );
        await registerCampaign(payload);
        setCurrentStep(prev => prev + 1);
        setSubLabel(null);
      } catch (error) {
        handleOpenSnackbar(
          error?.response?.data?.message ?? 'Algo salió mal, intenta de nuevo.',
          TYPES.ERROR,
        );
      } finally {
        setIsSubmitting(false);
      }
      return;
    }

    setCurrentStep(prev => prev + 1);
    setSubLabel(null);
  };

  const handleFinish = () => {
    window.location.href = '/';
  };

  const displayLabel = subLabel || STEPS[currentStep].label;

  return (
    <PageWrapper>
      <Header>
        <StepDots>
          {STEPS.map((step, i) => (
            <StepDot key={step.label} active={i === currentStep} />
          ))}
        </StepDots>
        <StepLabel>
          PASO {currentStep + 1} DE {STEPS.length} · {displayLabel}
        </StepLabel>
      </Header>

      {currentStep === 0 && (
        <StepUbicacion onNext={handleNext} onSubLabel={setSubLabel} />
      )}
      {currentStep === 1 && (
        <StepDatos onNext={handleNext} isLoading={isSubmitting} />
      )}
      {currentStep === 2 && <StepConfirmacion onFinish={handleFinish} />}
    </PageWrapper>
  );
}
